function filterGames(games, filter) {
  return games.filter(g => g.limit === filter);
}

function getCurrencyStr(str) {
  return parseFloat(str).toLocaleString("en-US", { style: "currency", currency: "USD", minimumFractionDigits: 0 });
}

export default function MccGamesTable({ data }) {
  const noLimit = filterGames(data, 'No Limit');
  const limit = filterGames(data, 'Limit');

  return (
    <section aria-labelledby="games-heading" className="">
      <div className="vstack gap-3 bg-white p-3 rounded">
        <h3 id="games-heading" className="h4 mb-0 text-primary">
          Live Games
        </h3>

        <div className="row gy-3">
          <div className="col-xl-7">
            <table className='table table-responsive table-bordered m-0' style={{'--bs-table-bg': 'transparent'}}>
              <thead>
              <tr>
                <th scope="col" className="subhead-3 text-primary">No Limit Cash Games</th>
                <th scope="col" className="subhead-3 text-gray text-center">Buy-In</th>
              </tr>
              </thead>

              <tbody>
              {noLimit.map((game) => (
                <tr key={game.id}>
                  <td className="fw-medium">{game.name}</td>
                  <td className="text-center">
                    {getCurrencyStr(game.buy_in.min)}
                    {game.buy_in.max ? '–' + getCurrencyStr(game.buy_in.max) : false}
                  </td>
                </tr>
              ))}
              </tbody>
            </table>
          </div>

          <div className="col-xl-5">
            <table className='table table-responsive table-bordered m-0' style={{'--bs-table-bg': 'transparent'}}>
              <thead>
              <tr>
                <th scope="col" className="subhead-3 text-primary">Limit Cash Games</th>
                <th scope="col" className="subhead-3 text-gray text-center">Buy-In</th>
              </tr>
              </thead>

              <tbody>
              {limit.map((game) => (
                <tr key={game.id}>
                  <td className="fw-medium">{game.name}</td>
                  <td className="text-center">
                    {getCurrencyStr(game.buy_in.min)} Minimum
                  </td>
                </tr>
              ))}
              </tbody>
            </table>
          </div>
        </div>


        <div className="text-center fw-normal text-dark">
          <p className="mb-0">
            We also offer 7 Card Stud & Omaha Hi-Lo on demand.
          </p>
        </div>
      </div>
    </section>
  )
}
